import { useQueryContext } from './chunk-OYSCTTI3.mjs';
import { useAuthContext } from './chunk-K3UDKV2P.mjs';
import { __spreadProps, __spreadValues, __async } from './chunk-4U7ZT42S.mjs';
import { useMutation } from '@tanstack/react-query';
import request from 'graphql-request';

var useMutationRequest = (props) => {
  const { document, getAccessToken, options } = props;
  const { hasuraUrl } = useQueryContext();
  const { isSignedIn, signOut } = useAuthContext();
  return useMutation(__spreadProps(__spreadValues({}, options), {
    mutationFn: (variables) => __async(null, null, function* () {
      let headers = {
        "content-type": "application/json"
      };
      if (typeof getAccessToken !== "undefined") {
        if (!isSignedIn) {
          signOut();
          throw new Error("Session expired. Please sign in again.");
        }
        let token;
        try {
          token = yield getAccessToken();
          if (!token) {
            throw new Error("Invalid access token");
          }
          headers = __spreadProps(__spreadValues({}, headers), {
            Authorization: `Bearer ${token}`
          });
        } catch (error) {
          console.error("Authentication failed:", error);
          throw error;
        }
      }
      try {
        return request({
          url: hasuraUrl,
          document: document.toString(),
          requestHeaders: headers,
          variables
        });
      } catch (error) {
        console.error("GraphQL mutation failed:", error);
        throw error;
      }
    })
  }));
};

export { useMutationRequest };
//# sourceMappingURL=chunk-6WWPXI47.mjs.map
//# sourceMappingURL=chunk-6WWPXI47.mjs.map